import { createContext, useContext } from 'react';

export const AuthContext = createContext({
  user: undefined,
  konfiguration: undefined,
  isLoading: false,
  setUser: () => {},
  logout: () => {},
});

export const useAuthContext = () => useContext(AuthContext);
